import React from "react";
import { useEffect, useState } from "react";
import { getFirestore, onSnapshot, collection, query, orderBy, limitToLast, addDoc, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import Message from "./Message";
import useSound from 'use-sound';
// @ts-ignore
import boopSfx from '../assets/notification-sound.mp3';

const Channel = () => {
    
    const db = getFirestore();
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [initializing, setInitializing] = useState(true);
    const { uid, displayName, photoURL } = getAuth().currentUser;
    const [play] = useSound(boopSfx);



    useEffect(() => {
        if (db) {
            const q = query(collection(db, "messages"), orderBy("createdAt", "asc"), limitToLast(100));
            const unsubscribe = onSnapshot(q, snapshot => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setMessages(data);
                setInitializing(false);
                scrollToBottom();
                play();
                }
            );
            return unsubscribe
        }
        scrollToBottom()
    }, [db,play]);

    const handleOnChange = e => {
        setNewMessage(e.target.value)
    }

    const handleOnSubmit = e => {
        e.preventDefault();

        if (db) {
            const docData = {
                text: newMessage,
                createdAt: serverTimestamp(),
                uid,
                displayName,
                photoURL,
            };
            addDoc(collection(db, "messages"), docData);
            setNewMessage('');
            scrollToBottom();
        }
    }

    const scrollToBottom = () => window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth"
    });
    
    return (
        <div>
            {initializing ? <div className='flex justify-center items-center h-screen w-screen'>
                <div className='flex flex-col place-items-center'>
                    <h1 className='text-white text-center mb-5'>Initialize...</h1>
                </div>
            </div> : <div className="sm:mx-6 mx-2 my-8">
                <ul>
                    {messages.map(message => (
                        <li key={message.id}><Message {...message} /></li>
                    ))}
                </ul>
                <form onSubmit={handleOnSubmit}>

                    <div className="flex">
                        <input
                            type="text"
                            value={newMessage}
                            onChange={handleOnChange}
                            className="rounded-none rounded-l-lg bg-neutral-100 dark:bg-gray-600 text-gray-800 dark:text-white block flex-1 min-w-0 w-full text-sm p-2.5 focus:outline-none text-xs sm:text-base"
                            placeholder="Type Your message here..." />
                        <button
                            type="submit"
                            disabled={!newMessage}
                            className="bg-blue-700 hover:bg-blue-800 inline-flex items-center px-3 text-sm text-white font-semibold rounded-r-md border-r-0 ">
                            Send
                        </button>
                    </div>
                </form>
            </div>}
        </div>

    )
}

export default Channel;